import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {Button} from "primereact/button";
import {IDropdownOption} from "@xal3xfx/react-utils/dist/util-service";
import {Dropdown} from "primereact/dropdown";
import {MultiSelect} from "primereact/multiselect";
import {ClientInvoicesSummary} from "../../lib/types/types";
import {formatNumber} from "../../lib/common";

export type MobileFilters = { [key in 'statusId' | 'clientId']: number | undefined };

interface Props {
    onFilterApply: (filters: MobileFilters) => void,
    clientOptions: ClientInvoicesSummary[] | IDropdownOption[],
    isClientOptionsDropdown: boolean,
    statusOptions: IDropdownOption[],
    filters: MobileFilters,
    statusClassNameMap: { [key: string]: string },
    showClientFilter: boolean
}

const initialFilters: MobileFilters = {clientId: undefined, statusId: undefined}

export const MobileInvoiceFilters: React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);
    const [filters, setFilters] = useState<MobileFilters>(props.filters || initialFilters);

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    const statusItemTemplate = (option: any) => {
        const className = props.statusClassNameMap[option.description];
        return <div key={option.key} style={{display: 'flex', justifyContent: 'center'}}><span
            style={{display: 'flex', justifyContent: 'center'}}
            className={className}>{f({id: option.description})}</span></div>;
    };

    const selectedStatusTemplate = (option: any) => {
        var statusOption = props.statusOptions!.find(el => el.id === option)
        if (statusOption)
            return <div key={statusOption.key}>
                {f({id: statusOption.description})}
            </div>
        return "Изберете"
    }

    useEffect(() => {
        console.log(filters);
    }, [filters])

    const clientFilterTemplate = (option: ClientInvoicesSummary) => {
        if (option) {
            const hasUnpaidInvoices = option.hasUnpaidInvoices;
            const label = option.clientName;
            const restAmount = option.invoicesRestAmount;
            return (
                <div className={!hasUnpaidInvoices ? "paid-invoice" : ""}>{`${label} ${formatNumber(restAmount)}`}</div>
            );
        }
        return <span>{"Asdf"}</span>;
    };

    return <>
        <div className={'grid justify-content-center p-fluid mt-5'}>
            {props.showClientFilter && <div className="p-field col-12 md:col-6">
                <span className="p-float-label">
                    <Dropdown filter={true} options={props.clientOptions}
                              filterInputAutoFocus={true}
                              optionValue={props.isClientOptionsDropdown ? 'id' : 'clientId'}
                              itemTemplate={props.isClientOptionsDropdown ? undefined : clientFilterTemplate}
                              optionLabel={props.isClientOptionsDropdown ? 'description' : 'clientName'}
                              onChange={e => setFilters({...filters, clientId: e.value})}
                              value={filters.clientId} placeholder={f({id: 'chooseLabel'})}/>
                    <label>{f({id: "client"})}</label>
                </span>
            </div>
            }
            <div className="p-field col-12 md:col-6">
                <span className="p-float-label">
                    <MultiSelect filter={true} options={props.statusOptions} optionLabel={'description'}
                                 optionValue={'id'} onChange={e => setFilters({...filters, statusId: e.value})}
                                 value={filters.statusId} placeholder={f({id: 'chooseLabel'})}
                                 itemTemplate={statusItemTemplate} selectedItemTemplate={selectedStatusTemplate}/>
                    <label>{f({id: "status"})}</label>
                </span>
            </div>
        </div>
        <div className={`grid justify-content-center p-fluid mt-3`}>
            <div className={'col-12 md:col-3 lg:col-3 xl:col-2'}>
                <Button icon={'pi pi-check'} type={'button'} onClick={() => props.onFilterApply(filters)}
                        label={f({id: "applyFilters"})}/>
            </div>
            <div className={'col-12 md:col-3 lg:col-3 xl:col-2'}>
                <Button icon={'pi pi-times'} type="button" onClick={() => setFilters(initialFilters)}
                        label={f({id: "reset"})}/>
            </div>
        </div>
    </>
};
